import { canonicalJsonStringify, jsonValueSchema, pendingSyncOperationSchema, syncEntityPayloadSchema, uuidSchema, } from '@der-maschinfuehrer/contracts';
export function parseLegacyShiftAggregateEnvelope(input) {
    const inputJson = jsonValueSchema.parse(input);
    if (typeof inputJson !== 'object' || inputJson === null || Array.isArray(inputJson)) {
        throw new Error('legacy shift aggregate envelope must be an object');
    }
    const row = inputJson;
    const datasetEpoch = uuidSchema.parse(row.dataset_epoch);
    const canonicalEntity = entityRowFromPayload({
        entity_type: 'shift_aggregate',
        value: row.aggregate,
    }, datasetEpoch);
    assertPayloadDatasetEpoch(canonicalEntity.payload, datasetEpoch);
    if (canonicalEntity.payload.entity_type !== 'shift_aggregate') {
        throw new Error('legacy shift aggregate payload has another entity type');
    }
    const canonical = {
        shift_id: canonicalEntity.entity_id,
        dataset_epoch: canonicalEntity.dataset_epoch,
        revision: canonicalEntity.revision,
        updated_at: canonicalEntity.updated_at,
        aggregate: canonicalEntity.payload.value,
    };
    if (canonicalJsonStringify(inputJson) !== canonicalJsonStringify(canonical)) {
        throw new Error('legacy shift aggregate envelope differs from its canonical payload projection');
    }
    return canonical;
}
export function payloadIdentity(payload) {
    switch (payload.entity_type) {
        case 'shift_aggregate':
            return {
                entity_id: payload.value.shift.shift_id,
                revision: payload.value.aggregate_revision,
                updated_at: payload.value.shift.metadata.updated_at,
                tombstone_deleted_at: payload.value.shift.metadata.tombstone?.deleted_at ?? null,
            };
        case 'vehicle':
            return metadataIdentity(payload.value.vehicle_id, payload.value.metadata);
        case 'route_variant':
            return metadataIdentity(payload.value.route_variant_id, payload.value.metadata);
        case 'route_template':
            return metadataIdentity(payload.value.route_template_id, payload.value.metadata);
        case 'user_defined_location':
            return metadataIdentity(payload.value.location_id, payload.value.metadata);
        case 'location_merge_decision':
            return metadataIdentity(payload.value.decision_id, payload.value.metadata);
        case 'user_preferences':
            return metadataIdentity(payload.value.user_preferences_id, payload.value.metadata);
    }
}
export function entityRowFromPayload(payloadInput, datasetEpoch) {
    const payload = syncEntityPayloadSchema.parse(payloadInput);
    const identity = payloadIdentity(payload);
    return {
        compound_key: [payload.entity_type, identity.entity_id],
        entity_type: payload.entity_type,
        entity_id: identity.entity_id,
        dataset_epoch: datasetEpoch,
        revision: identity.revision,
        updated_at: identity.updated_at,
        tombstone_deleted_at: identity.tombstone_deleted_at,
        payload,
    };
}
export function parseEntityRowEnvelope(input, expectedDatasetEpoch) {
    const inputJson = jsonValueSchema.parse(input);
    if (typeof inputJson !== 'object' || inputJson === null || Array.isArray(inputJson)) {
        throw new Error('entity row envelope must be an object');
    }
    const row = inputJson;
    const datasetEpoch = uuidSchema.parse(row.dataset_epoch);
    if (expectedDatasetEpoch !== undefined && datasetEpoch !== expectedDatasetEpoch) {
        throw new Error('entity row envelope belongs to another dataset epoch');
    }
    const canonical = entityRowFromPayload(row.payload, datasetEpoch);
    assertPayloadDatasetEpoch(canonical.payload, datasetEpoch);
    if (canonicalJsonStringify(inputJson) !== canonicalJsonStringify(canonical)) {
        throw new Error('entity row envelope differs from its canonical payload projection');
    }
    return canonical;
}
export function parsePendingOperation(input) {
    return pendingSyncOperationSchema.parse(input);
}
export function entityTableKey(entityType, entityId) {
    return [entityType, entityId];
}
function metadataIdentity(entityId, metadata) {
    return {
        entity_id: entityId,
        revision: metadata.revision,
        updated_at: metadata.updated_at,
        tombstone_deleted_at: metadata.tombstone?.deleted_at ?? null,
    };
}
function assertPayloadDatasetEpoch(payload, datasetEpoch) {
    if (payload.entity_type === 'shift_aggregate') {
        if (payload.value.dataset_epoch !== datasetEpoch) {
            throw new Error('shift aggregate payload belongs to another dataset epoch');
        }
        return;
    }
    if (payload.value.metadata.tombstone !== null &&
        payload.value.metadata.tombstone.dataset_epoch !== datasetEpoch) {
        throw new Error('entity tombstone belongs to another dataset epoch');
    }
}
//# sourceMappingURL=entity.js.map